import useDropdownContext from '../../dropdown-context';
import { isMobileDisplay } from '~/helpers/device';
function findNext(dropdownRef) {
    var _a;
    const nextSib = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
    if (nextSib === null || nextSib === void 0 ? void 0 : nextSib.matches('a')) {
        return nextSib;
    }
    const targets = Array.from(dropdownRef.current.querySelectorAll('a'));
    const idx = targets.indexOf(document.activeElement);
    const nextIdx = (idx + 1) % targets.length;
    return targets[nextIdx];
}
function findPrev(topRef, dropdownRef) {
    var _a;
    const prevSib = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
    if (prevSib === null || prevSib === void 0 ? void 0 : prevSib.matches('a')) {
        return prevSib;
    }
    const targets = Array.from(dropdownRef.current.querySelectorAll('a'));
    const idx = targets.indexOf(document.activeElement);
    if (idx === 0) {
        return topRef.current;
    }
    const prevIdx = (idx + targets.length - 1) % targets.length;
    return targets[prevIdx];
}
export default function useNavigateByKey({ topRef, dropdownRef, closeMenu, closeDesktopMenu }) {
    const { activeDropdown } = useDropdownContext();
    // eslint-disable-next-line complexity
    function navigateByKey(event) {
        var _a;
        if (isMobileDisplay()) {
            if (event.key === 'Escape' && activeDropdown.current) {
                const focusReturnsTo = activeDropdown.current;
                closeMenu();
                focusReturnsTo.focus();
                event.stopPropagation();
            }
            if (event.key.startsWith('Arrow') ||
                ['Home', 'End'].includes(event.key)) {
                event.preventDefault();
            }
            return;
        }
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                if (document.activeElement === topRef.current) {
                    (_a = dropdownRef.current.firstChild) === null || _a === void 0 ? void 0 : _a.focus();
                }
                else {
                    findNext(dropdownRef).focus();
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (document.activeElement !== topRef.current) {
                    findPrev(topRef, dropdownRef).focus();
                }
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                event.target.blur();
                closeDesktopMenu();
                break;
            default:
                break;
        }
    }
    return navigateByKey;
}
